module.exports = __webpack_public_path__ + "static/media/ico_recompensas.91f6f5c4.png";